import React, { useState } from 'react';
import PropTypes, { func, string, bool } from 'prop-types';
import { View } from 'react-native';
import { Button } from 'LocalGluons/index';
import RadioButtonSelectBox from 'LocalGluons/components/RadioButtonSelectBox';
import { t } from 'Locale/index';

import { pageConfig } from 'Pages/RecordPage';

import defaultStyles from './RecordPageButtons.jss';

export const RecordPageButtons = ({
    onCancel,
    onAccept,
    page,
    isLandscape,
    displayExitCancel,
    children
}) => {
    const { buttons, buttonTitle } = pageConfig[page]();
    const [radioItems, setRadioItems] = useState(buttons || []);

    const onRadioButtonSelect = (selectedItem, index, newItems) => {
        setRadioItems(newItems);
    };

    return (
        <View style={defaultStyles.container}>
            <View
                style={[
                    defaultStyles.optionsContainer,
                    isLandscape ? defaultStyles.optionsContainerLandscape : {}
                ]}
            >
                {!isLandscape && children}
                <View style={defaultStyles.radioButtonsContainer}>
                    <RadioButtonSelectBox onSelect={onRadioButtonSelect} items={radioItems} />
                </View>
                {isLandscape && children}
            </View>
            <View
                style={[
                    defaultStyles.buttonsContainer,
                    isLandscape ? defaultStyles.buttonsContainerLandscape : {}
                ]}
            >
                <Button
                    style={{
                        button: [
                            defaultStyles.button,
                            isLandscape ? defaultStyles.buttonPrimary : {}
                        ]
                    }}
                    title={t(buttonTitle)}
                    isSecondary={!displayExitCancel}
                    onPress={() => onAccept(radioItems[1] ? radioItems[1].isSelected : false)}
                    testID="record_button"
                />
                {displayExitCancel && (
                    <Button
                        style={{
                            button: [
                                defaultStyles.button,
                                isLandscape ? defaultStyles.buttonSecondary : {}
                            ]
                        }}
                        isSecondary
                        title={t('RECORDINGS.BTN_CANCEL')}
                        onPress={onCancel}
                        testID="cancel_button"
                    />
                )}
            </View>
        </View>
    );
};

RecordPageButtons.defaultProps = {
    isLandscape: false,
    children: [],
    displayExitCancel: true
};

RecordPageButtons.propTypes = {
    page: string.isRequired,
    onCancel: func.isRequired,
    onAccept: func.isRequired,
    isLandscape: bool,
    displayExitCancel: bool,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
